<div class="not-found-wrapper">
    <h1>404</h1>
    <p>The page you were looking for does not exist.</p>
    <span>You may have mistyped the address or the page may have moved.</span>
    <a [routerLink]="['/home']" class="btn btn-lg btn-primary">Home Page</a>
</div>